import { useState } from "react";
import Icon from "./Icon";
import { faqs } from "../siteContent";

const FAQs = () => {
  const [openItem, setOpenItem] = useState(0);

  return (
    <section className="section section--warm" id="faqs">
      <div className="container faq-layout">
        <div className="faq-layout__intro">
          <p className="eyebrow">Frequently asked questions</p>
          <h2>Helpful answers as you consider care</h2>
          <p>
            Choosing a care home can bring up many questions. These are useful
            starting points; the team is happy to talk through your individual
            circumstances.
          </p>
          <a className="text-link" href="#contact">
            Ask us a question
            <Icon name="arrow" size={19} />
          </a>
        </div>

        <div className="accordion">
          {faqs.map(({ question, answer }, index) => {
            const isOpen = openItem === index;
            const panelId = `faq-panel-${index}`;
            const buttonId = `faq-button-${index}`;

            return (
              <div className={`accordion__item${isOpen ? " is-open" : ""}`} key={question}>
                <h3>
                  <button
                    aria-controls={panelId}
                    aria-expanded={isOpen}
                    id={buttonId}
                    onClick={() => setOpenItem(isOpen ? -1 : index)}
                    type="button"
                  >
                    <span>{question}</span>
                    <span aria-hidden="true" className="accordion__symbol">
                      {isOpen ? "−" : "+"}
                    </span>
                  </button>
                </h3>
                <div
                  aria-labelledby={buttonId}
                  className="accordion__panel"
                  hidden={!isOpen}
                  id={panelId}
                  role="region"
                >
                  <p>{answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
